import React from "react";
import * as XLSX from "xlsx";
import "./ExportCard.css";

const ExportCard = ({ data, fileName = "exported_data.xlsx" }) => {
  const handleExport = () => {
    if (!data || data.length === 0) {
      alert("No data available to export.");
      return;
    }

    // Convert JSON data to worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Filtered Data");

    // Create and download the XLSX file
    XLSX.writeFile(workbook, fileName);
  };

  return (
    <div className="export-card">
      <h3 className="export-title">Export Data</h3>
      <button className="export-btn" onClick={handleExport}>
        Download XLSX
      </button>
    </div>
  );
};

export default ExportCard;
